module.exports = __webpack_public_path__ + "static/media/irish-international-freight-association.3535456f.png";